import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { LoginRegister } from "../../login/LoginRegister";
import { AuthParamList } from "./AuthParamList";
import { ServiceNumber } from "../../login/ServiceNumber";
import { ForgotPassword } from "../../login/ForgotPassword";
import React from "react";
import { OpenSecurity } from "../../setting/OpenSecurity";
import { useRoute } from "@react-navigation/native";
import { RetrievePsd } from "../../login/RetrievePsd";
import { AuthCountryCodeSelete } from "../../CountryCodeSelete";
import { AuthCommonWeb } from "../../login/AuthCommonWeb";
import { UpgradeGuideScreen } from "../../login/UpgradeGuideScreen";
import QRCodeLogin from "../../login/QRCodeLogin";


const Stack = createNativeStackNavigator<AuthParamList>();

export const AuthStack = () => {
  console.log("🟢 [AuthStack] 组件开始渲染");
  const route = useRoute();
  console.log("🟢 [AuthStack] Route params:", route.params);

  return (
    <Stack.Navigator
      screenOptions={{ headerShown: false, }}
      initialRouteName="QRCodeLogin"
    >
      {/* <Stack.Screen
        name="ServiceNumber"
        component={ServiceNumber}
        initialParams={route.params}
      />
      <Stack.Screen
        name="Login"
        component={LoginRegister}
        initialParams={route.params}
      />
      <Stack.Screen name="OpenSecurity" component={OpenSecurity} />
      <Stack.Screen name="ForgotPassword" component={ForgotPassword} />
      <Stack.Screen
        name={"AuthCountryCodeSelete"}
        component={AuthCountryCodeSelete}
      />
      <Stack.Screen name={"AuthCommonWeb"} component={AuthCommonWeb} />
      <Stack.Screen
        name={"UpgradeGuideScreen"}
        component={UpgradeGuideScreen}
        options={{
          headerShown: false,
          presentation: "transparentModal", // 或 'modal'
          animation: "fade", // 或 'fade'
        }}
      /> */}
      <Stack.Screen name={"QRCodeLogin"} component={QRCodeLogin} />

    </Stack.Navigator>
  );
};
